import { SortType } from '@home/enums/common';
import { SortInteractionMode } from '../enums';

// 排序方式列表
const SORT_TYPES = [SortType.None, SortType.Desc, SortType.Asc];

/**
 * 获取新的排序方式（不允许重置为不排序状态）
 * @param sortType 当前排序方式
 * @return 新的排序方式
 */
const getNextSortType1 = (sortType?: SortType): SortType => {
  if (sortType === SortType.None) return SortType.Desc;
  return sortType === SortType.Desc ? SortType.Asc : SortType.Desc;
};

/**
 * 获取新的排序方式（允许重置为不排序状态）
 * @param sortType 当前排序方式
 * @return 新的排序方式
 */
const getNextSortType2 = (sortType?: SortType): SortType => {
  const currentSortTypeIndex = !sortType ? 0 : SORT_TYPES.indexOf(sortType) ?? 0;
  return SORT_TYPES[(currentSortTypeIndex + 1) % SORT_TYPES.length];
};

/**
 * 获取新的排序方式（内部判断返回具体实现的方法）
 * @param useResetSortTypeNone 是否开启重置为不排序状态
 * @return 获取新的排序方式
 */
export const getNextSortTypeIntelligence = (useResetSortTypeNone: boolean) => {
  return useResetSortTypeNone ? getNextSortType2 : getNextSortType1;
};

/**
 * 获取排序的交互模式
 * @param options 排序的扩展项列表
 * @return 排序的交互模式
 */
export const getSortInteractionMode = (options?: Readonly<ISortOption>[] | null): SortInteractionMode => {
  return Array.isArray(options) && options.length > 1
    ? SortInteractionMode.OptionsMode
    : SortInteractionMode.DirectMode;
};
